<style lang="less">
    @import "../../../styles/radioAndCheckbox.less";
</style>
<template>
  <div class="generalframezz">
    <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">

      <div  class="general_title" :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}">
        <div class="general_title_left">
          <div>{{myTitle}}</div>
        </div>
        <img @click="parentHandleclick()" class="timgclose" src="../verificationOriginal/images/ty_close.png" alt='版权登记'/>
      </div>
<!--      内容-->
      <div class="verify-code">
<!--          作者列表-->
        <div class="verify_conent">
            <div  class="verify_item" v-if="isRadio=='false'"  v-for="(autor,index) in showData">
                <input type="checkbox"  v-model="autor.checked" style=" margin-right: 15px;" /><span>{{autor.name}}</span>
            </div>
            <div class="verify_item"  v-if="isRadio=='true'"  v-for="(autor,index) in showData">
                <!--<input type="radio" name="obligeeName"  :value="autor"  style=" margin-right: 15px;"  v-model="radioCheck" :checked="autor.checked" />-->
                <input type="radio" name="obligeeName"  :value="autor"  style=" margin-right: 15px;"  v-model="radioCheck"  />
                <span>{{autor.name}}</span>
            </div>
            <div class="addzuozhe" @click="onObligee">{{myTitle}}</div>
        </div>
<!--       分页-->
        <div  v-if="isShowPage" class="commont-page" style="margin-top: 10px;">
            <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small"
                  show-total show-elevator class="page-size-style"></Page>
<!--            <span class="page-total-span">/&nbsp;{{pages}}页</span>-->
        </div>
<!--          确定按钮-->
      <button @click="addAutor" class="btn_blue">确认添加</button>
      </div>


<!--    content end-->
    </div>
  </div>
</template>

<script>

const reImg = /^(bmp|png|jpg|gif|jpeg)$/;
const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
export default {
  name: "certAutorVerify",
  props:{
    mywidth:{
      type:String,
      default:'600'
    },
    myheight:{
      type:String,
      default:'550'
    },
    myTitleheight:{
      type:String,
      default:'85'
    },
    myTitle:{
      type:String,
      default:"添加作者"
    },
     obligeeArr:{
        type:Array
     },
      obliggeType:{
        type:String,
          defalut:"1"
      },
      isRadio:{
        type:String,
          default:"false"
      }
  },

  data(){
    return{
      // autors:[{name:"张三",checked:false},{name:"李四",checked: false}]
        radioCheck:"",
        pageSize:8,
        total:0,
        pages:1,
        pageNumber:1,
        isShowPage:false,
        showData:[], //每页显示的数据
    }
  },
    created(){
      //一页显示8个，判断 总个数是否大于8，如果小于，则分页不显示
      if(this.obligeeArr.length > this.pageSize){
          this.isShowPage = true ;
          this.total = this.obligeeArr.length ;
          this.showData = this.obligeeArr.slice(0,8)
      }else{
          this.showData = this.obligeeArr ;
      }
    },
  methods:{
     // 打开权利人管理
    onObligee(){
        window.open('/obligee','_blank')
    },
    parentHandleclick() {
      this.$emit('fatherModal',null);
    },
    changepage(index){
        this.pageNumber = index;
        console.log(this.pageNumber);
        this.showData = this.obligeeArr.slice((this.pageNumber-1)*8,this.pageNumber*8);
    },
    addAutor(){
        // debugger ;
        // console.log(this.radioCheck);
        let selectedAutor = [];
        if(this.isRadio=='true' && this.radioCheck != ""){
            selectedAutor.push(this.radioCheck);
        }else{
            selectedAutor = this.obligeeArr.filter( item=>item.checked === true);
        }
        this.$emit("fatherModal",selectedAutor);
    }
  },

};
</script>
<style scoped lang="less">
    .btn_blue{
        width: 119px;
        height: 40px;
        background: #ffd800;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 20px;
        letter-spacing: 1px;
        outline: none;
        border: none;
        cursor: pointer;
    }
  .generalframezz{
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    margin: auto;
    z-index: 558;
    .generalcontent{
      background:#fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius:8px;
      .general_title{
        border-bottom:1px solid rgba(236,236,236,1);
        font-size:16px;
        font-weight:400;
        color:rgba(50,50,50,1);
        display:flex;
        justify-content: space-between;
        padding:0 30px;
        align-items: center;
        .general_title_left{
          display:flex;
          justify-content: flex-start;
          align-items: center;
        }
        .timgtishi{
          width:25px;
          height:25px;
          margin-right:10px;
        }
        .timgclose{
          width:18px;
          height:18px;
          cursor: pointer;
        }
      }
      .verify-code{
        width:600px;
        height:450px;
        background:rgba(252,252,252,1);
        border-radius:0px 0px 8px 8px;
        /*text-align: center;*/
        display: flex;
        flex-direction: column;
        /*justify-content: center;*/
        align-items: center;
        overflow: hidden;

        .verify_conent{
          width: 100%;
          height:325px;
          /*margin-top: 30px;*/
          display: flex;
          flex-direction: column;
          align-items: flex-start;
            .verify_item{
                display: flex;
                align-items: center;
                width: 100%;
                height: 48px;
                padding-left: 30px;
                border-bottom: 1px solid rgba(238,238,238,1);

                input[type=checkbox]:checked:after{
                    /*transform: rotate(10deg) translate(18%, -42%);*/
                }
            }
        }
        .addzuozhe{
          line-height: 48px;
          font-size: 14px;
          font-weight: 400;
          color: #f7b500;
          text-decoration: underline;
          cursor: pointer;
          width: 100%;
          text-align: left;
          padding: 0 30px;
        }

        .verifybtn{
          width:163px;
          height:52px;
          background:rgba(33,80,163,1);
          border-radius:26px;
          border:0;
          outline: none;
          cursor: pointer;
          font-size:18px;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:27px;
            margin-top:20px;
        }
          .verifybtn:hover{
              color:rgba(255,255,255,0.9);
          }
      }
    }
  }
</style>
